// ---------------------------------------------------------------------------
// Gates de avanço por etapa do pipeline (pedido 2026-07-15: "campos
// obrigatórios de cada etapa são gate pra liberação de etapas").
//
// Regra por etapa (o que precisa estar completo pra liberar o "Avançar"):
//   BACKGROUND_CHECK    → as 2 sub-análises APROVADO (espelha o gate do
//                         backend — 422 background_check_not_approved)
//   COLETA_DOCS         → todo documento do checklist recebido ou marcado
//                         "não se aplica" (inclui docs de dependentes)
//   PRE_CADASTRO        → os 5 campos obrigatórios (*) preenchidos
//   EXAME_ADMISSIONAL   → resultado APTO + laudo anexado (INAPTO não avança —
//                         o caminho é desqualificar)
//   RASCUNHO_ONVIO      → caixa "Rascunho Onvio pronto" marcada
//   ENVIO_CONTABILIDADE → data de envio à contabilidade registrada
//   AGUARDANDO_INICIO   → não tem avanço (a saída é a ação ADMITIR, que tem
//                         pré-check próprio no AdmitModal)
//
// ATENÇÃO: exceto o do background check, estes gates são GUARD-RAILS DE UI —
// o backend só impõe o do BC. Se um dia precisarem ser garantia (à prova de
// outros clientes), replicar no backend via handoff (mesma filosofia do 0066).
// ---------------------------------------------------------------------------

import {
   ONBOARDING_STATUS,
   ADMISSION_DOCUMENT_STATUS,
   ADMIT_REQUIRED_PRE_CADASTRO_FIELDS,
} from '../constants';

function isFilled(value) {
   return value !== null && value !== undefined && value !== '';
}

// → { blocked: boolean, reason: string | null }
export function advanceGateFor(status, { onboarding, documents = [] }) {
   switch (status) {
      case ONBOARDING_STATUS.BACKGROUND_CHECK: {
         const approved =
            onboarding?.litigation_screening_status === 'APROVADO' &&
            onboarding?.professional_history_status === 'APROVADO';
         return approved
            ? { blocked: false, reason: null }
            : {
                 blocked: true,
                 reason:
                    'Conclua as duas análises (aprovadas) para liberar o avanço.',
              };
      }

      case ONBOARDING_STATUS.COLETA_DOCS: {
         const pendingCount = documents.filter(
            (doc) =>
               doc.status !== ADMISSION_DOCUMENT_STATUS.NAO_APLICA &&
               doc.status !== ADMISSION_DOCUMENT_STATUS.RECEBIDO &&
               doc.status !== ADMISSION_DOCUMENT_STATUS.ENVIADO_CONTABILIDADE,
         ).length;
         return pendingCount === 0
            ? { blocked: false, reason: null }
            : {
                 blocked: true,
                 reason: `Receba os ${pendingCount} documento(s) pendente(s) do checklist (ou marque "não se aplica" nos condicionais) para liberar o avanço.`,
              };
      }

      case ONBOARDING_STATUS.PRE_CADASTRO: {
         const missing = ADMIT_REQUIRED_PRE_CADASTRO_FIELDS.filter(
            (field) => !isFilled(onboarding?.[field.key]),
         );
         return missing.length === 0
            ? { blocked: false, reason: null }
            : {
                 blocked: true,
                 reason: `Preencha os campos obrigatórios do pré-cadastro (${missing
                    .map((field) => field.label)
                    .join(', ')}) para liberar o avanço.`,
              };
      }

      case ONBOARDING_STATUS.EXAME_ADMISSIONAL: {
         if (onboarding?.admission_exam_status !== 'APTO') {
            return {
               blocked: true,
               reason:
                  'Registre o resultado APTO do exame para liberar o avanço (INAPTO → desqualificar).',
            };
         }
         if (!onboarding?.has_admission_exam_document) {
            return {
               blocked: true,
               reason: 'Anexe o laudo do exame para liberar o avanço.',
            };
         }
         return { blocked: false, reason: null };
      }

      case ONBOARDING_STATUS.RASCUNHO_ONVIO:
         return onboarding?.onvio_draft_done
            ? { blocked: false, reason: null }
            : {
                 blocked: true,
                 reason:
                    'Marque "Rascunho Onvio pronto" (e salve) para liberar o avanço.',
              };

      case ONBOARDING_STATUS.ENVIO_CONTABILIDADE:
         return isFilled(onboarding?.sent_to_accounting_at)
            ? { blocked: false, reason: null }
            : {
                 blocked: true,
                 reason:
                    'Registre a data de envio à contabilidade (e salve) para liberar o avanço.',
              };

      default:
         return { blocked: false, reason: null };
   }
}
